import { useQuery } from "@sveltestack/svelte-query"
import { derived } from "svelte/store"

export function useBackendVersion() {
  const backendInfoQuery = useQuery("/api/features/backend", {refetchInterval: false, retry: 1})
  return derived(backendInfoQuery, backendInfoQuery => {
    return backendInfoQuery.data?.version ?? null
  })
}
